import DocViewShell from "@/components/DocViewShell";
import PlayingToWinBlueprint from "@/components/blueprints/PlayingToWinBlueprint";

export default function PlayingToWinView() {
  return (
    <DocViewShell
      eyebrow="Playing to Win Cascade"
      eyebrowClass="text-indigo-700"
      toolName="Playing to Win Cascade"
      editPathFn={(id) => `/ptw/${id}`}
      render={(doc) => <PlayingToWinBlueprint doc={doc} />}
    />
  );
}
